module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0115.jpg?v=5868712b";